import { render, staticRenderFns } from "./VATStatementDetails.vue?vue&type=template&id=5a61959e"
import script from "./VATStatementDetails.vue?vue&type=script&lang=js"
export * from "./VATStatementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports